<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { Label } from 'reka-ui'
import type { LabelProps } from 'reka-ui'
import { cn } from '@/utils/shadcn/lib/utils'
import { labelVariants } from './variants'
import { reactiveOmit } from '@vueuse/core'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

interface Props extends LabelProps {
    class?: HTMLAttributes['class'],
    for?: string,
    inline?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
    class: '',
    for: undefined,
    inline: false,
})

const delegatedProps = reactiveOmit(props, 'class', 'inline')
</script>

<template>
    <Label
        data-slot="label"
        v-bind="delegatedProps"
        :class="
            cn(
                labelVariants({
                    inline: props.inline
                }),
                props.class,
            )
        "
    >
        <slot></slot>
    </Label>
</template>
